import type { IconProps } from '@/types/general'

export const MinusCircle = (props: IconProps) => (
	<svg
		className={props.className}
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="21"
		viewBox="0 0 20 21"
		fill="none"
	>
		<line
			x1="5.5"
			y1="10.3164"
			x2="14.5"
			y2="10.3164"
			stroke="currentColor"
			strokeLinecap="round"
		/>
		<circle cx="10" cy="10.3164" r="9.5" stroke="currentColor" />
	</svg>
)
